/**
 * Translate page (pages/translate.js) + all TranslationStep* /
 * TranslateOptionsTab / TranslateSettingsTab / TranslationHistoryCard
 * localized copy.
 *
 * Re-export shim over /locales/{en,ht,fr,es}.json (translate key).
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.translate,
  ht: ht.translate,
  fr: fr.translate,
  es: es.translate,
  'pt-BR': ptBR.translate,
  'zh-Hans': zhHans.translate,
}

export default COPY
